export const minimumPasswordLength = 12;
export const maximumPasswordLength = 128;
export const passwordPolicyHint = 'От 12 до 128 символов. Используйте уникальный пароль или длинную фразу; распространённые пароли запрещены.';

export const validateNewPassword = (password: string, confirmation: string): string | null => {
  if (password.length < minimumPasswordLength || password.length > maximumPasswordLength) {
    return `Пароль должен содержать от ${minimumPasswordLength} до ${maximumPasswordLength} символов.`;
  }
  if (password !== confirmation) return 'Пароли не совпадают.';
  return null;
};
